<template>
  <a :class="classModifiers" :href="marketDetailUrl">
    <template v-if="isLayoutMobile">
      <div class="overview-map-contract__image-wrapper">
        <div class="overview-map-contract__image" :style="imageStyleModifiers"></div>
        <div
          v-if="false"
          class="overview-map-contract__indicator"
          :style="bgColorStyleModifiers"
        ></div>
        <div class="overview-map-contract__info">
          <span class="overview-map-contract__current-price">
            <template v-if="contractModel.hasLastTradePrice">
              <animated-number :value="contractModel.lastTradePriceAsCents"></animated-number>
            </template>
            <template v-else> - </template>
          </span>
          <market-change-price
            :price="contractModel.changePriceAsCents"
            :lastClosePrice="contractModel.lastClosePrice"
          >
          </market-change-price>
        </div>
      </div>
      <span class="overview-map-contract__title" :style="bgColorStyleModifiers">
        {{ item.shortName }}
      </span>
    </template>
    <template v-else>
      <div class="overview-map-contract__image-wrapper">
        <div class="overview-map-contract__image" :style="imageStyleModifiers"></div>
        <div
          v-if="false"
          class="overview-map-contract__indicator"
          :style="bgColorStyleModifiers"
        ></div>
      </div>
      <div class="overview-map-contract__info-wrapper">
        <span class="overview-map-contract__title" :style="bgColorStyleModifiers">
          {{ item.shortName }}
        </span>
        <div class="overview-map-contract__info">
          <span class="overview-map-contract__current-price">
            <template v-if="contractModel.hasLastTradePrice">
              <animated-number :value="contractModel.lastTradePriceAsCents"></animated-number>
            </template>
            <template v-else> - </template>
          </span>
          <market-change-price
            :price="contractModel.changePriceAsCents"
            :lastClosePrice="contractModel.lastClosePrice"
          >
          </market-change-price>
        </div>
      </div>
    </template>
  </a>
</template>
<script src="./overview-map-contract.js"></script>
<style src="./overview-map-contract.scss" lang="scss"></style>
